<script setup>
import AlertErrorIcon from './AlertErrorIcon.vue'

const props = defineProps({
  link: {
    type: String,
    default: null,
  },
})
</script>

<template>
  <a v-if="link" :href="link" class="text-dark p-2 pr-4 border-[#F54E4E] border-2 border-dashed text-base lg:text-xl flex gap-3 leading-normal items-start rounded-xl bg-[#FFF2F2]">
    <AlertErrorIcon class="text-alert-error min-w-7" />
    <slot />
  </a>
  <h4 v-else class="text-dark p-2 pr-4 border-[#F54E4E] border-2 border-dashed text-base lg:text-xl flex gap-3 leading-normal items-start rounded-xl bg-[#FFF2F2]">
    <AlertErrorIcon class="text-alert-error min-w-7" />
    <slot />
  </h4>
</template>
